import React from "react";
import "./Giveaway.css";
import insta from "../media/insta.png";

export default function Giveaway() {
    return (
        <div>
            <article class="project-tablettt">
                
            <figure class="ipaddd">
                <input type="radio" name="btnnn" id="layout" checked="checked"/>
                <label for="layout"></label>
                <input type="radio" name="btnnn" id="informacia"/>
                <label for="informacia"></label>
                <div class="screen-tablettt">
                <img src={insta} class="tabpage"/>
                </div>
                </figure>
            </article>

            </div>
    );
}